<nav class="sidebar" aria-label="Chats">
  <div class="sidebar__top">
    <a [routerLink]="['/chat']" class="sidebar__new" (click)="navigated.emit()">
      <span class="sidebar__new-icon" aria-hidden="true">
        <svg viewBox="0 0 20 20"><path d="M10 4.5v11M4.5 10h11" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
      </span>
      New chat
    </a>
    <button type="button" class="sidebar__icon-button" (click)="closed.emit()" aria-label="Close sidebar" title="Close sidebar">
      <svg viewBox="0 0 20 20" aria-hidden="true"><rect x="2.5" y="3.5" width="15" height="13" rx="2.5" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M7.5 3.5v13" stroke="currentColor" stroke-width="1.5"/></svg>
    </button>
  </div>

  <div class="sidebar__scroll">
    <h2 class="sidebar__label" *ngIf="threads.length">Recents</h2>
    <ul class="sidebar__threads">
      <li *ngFor="let thread of threads; trackBy: trackByThread"
          class="sidebar__thread"
          [class.sidebar__thread--active]="thread.thread_id === activeThread">
        <ng-container *ngIf="editing !== thread.thread_id; else editTitle">
          <a [routerLink]="['/chat', thread.thread_id]"
             class="sidebar__thread-link"
             [attr.aria-current]="thread.thread_id === activeThread ? 'page' : null"
             [title]="thread.title"
             (click)="navigated.emit()">{{ thread.title }}</a>
          <button type="button" class="sidebar__thread-menu"
                  [matMenuTriggerFor]="threadMenu" [matMenuTriggerData]="{ thread: thread }"
                  [attr.aria-label]="'Options for ' + thread.title" title="Options">
            <svg viewBox="0 0 20 20" aria-hidden="true"><circle cx="4.5" cy="10" r="1.5"/><circle cx="10" cy="10" r="1.5"/><circle cx="15.5" cy="10" r="1.5"/></svg>
          </button>
        </ng-container>
        <ng-template #editTitle>
          <input #titleInput class="sidebar__thread-title-input" type="text" maxlength="255"
                 aria-label="Chat name"
                 [value]="thread.title"
                 (keydown.enter)="saveTitle(thread, titleInput.value)"
                 (keydown.escape)="cancelRename()"
                 (blur)="saveTitle(thread, titleInput.value)"/>
        </ng-template>
      </li>
    </ul>
    <p class="sidebar__empty" *ngIf="!threads.length && !loading && !failed">Your chats will be listed here.</p>
    <p class="sidebar__empty sidebar__failed" *ngIf="failed" role="alert">
      Your chats could not be loaded.
      <button type="button" class="sidebar__retry" (click)="retry.emit()">Try again</button>
    </p>
    <button type="button" class="sidebar__more" *ngIf="hasMore" [disabled]="loading" (click)="loadMore.emit()">Show more</button>
  </div>
</nav>

<mat-menu #threadMenu="matMenu" class="chat-thread-menu">
  <ng-template matMenuContent let-thread="thread">
    <button mat-menu-item class="chat-thread-menu__rename" (click)="startRename(thread)">Rename</button>
    <button mat-menu-item class="chat-thread-menu__delete" (click)="remove.emit(thread)">Delete</button>
  </ng-template>
</mat-menu>
